import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M10.0101 12.5617C5.81013 14.5217 6.16015 19.3918 5.28015 27.9818C4.52015 35.3718 2.53015 43.8317 2.53015 43.8317C2.53015 43.8317 0.88014 30.7318 1.21014 21.9218C1.61014 11.3518 1.35013 11.3217 2.64013 1.28174H49.1601C50.6301 11.8617 50.3501 11.9117 50.7501 22.4717C51.0801 31.2817 49.2701 43.8317 49.2701 43.8317C49.2701 43.8317 47.2801 35.3618 46.5201 27.9818C45.6401 19.3918 45.9901 14.5317 41.7901 12.5617C38.4901 11.0217 34.1301 13.0017 26.0901 13.0017C18.0501 13.0017 13.3201 11.0217 10.0101 12.5617Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M26.05 1.05176V13.0018" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M29.2603 1.05176V13.0018" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M19.9202 1.05176V13.0018" stroke={outline} strokeMiterlimit="10" />
      <path d="M16.6001 1.05176V13.0018" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M12.6602 1.05176V13.0018" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M10.8901 1.05176V13.0018" stroke={outline} strokeMiterlimit="10" />
      <path d="M5.89014 1.05176L5.39014 13.0018L4.89014 1.05176H5.89014Z" fill={outline} />
      <path d="M30.8201 1.05176V13.0018" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M36.4202 1.36182V11.8018" stroke={outline} strokeMiterlimit="10" />
      <path d="M40.05 1.36182V11.5918" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M41.9202 1.36182V12.5618" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M47.8201 1.36182L47.3201 13.3218L46.8201 1.36182H47.8201Z" fill={outline} />
    </g>
  )
}
